import { h } from 'preact';
import { Text } from 'preact-i18n';
import StockList from '../stock-list';
import Container from '../container';
import { containerSize } from '@cube/blocks';


export function StocksPanel ({ width }) {
	let dollarVolumeColumns = ['symbolWithName', 'price', 'changePrice', 'dollarVolume'];
	let volumeColumns = ['symbolWithName', 'price', 'changePrice', 'changePercent'];

	// if we have the room, add
	if (width && width > 500) {
		dollarVolumeColumns.splice(2,0,'changePercent');
		volumeColumns.push('volume');
	}
	return (
		<Container parent>
			<Container title={<Text id="MOST_ACTIVE_STOCKS" />}>
				<StockList
					showHeaders
					query={{
						type: 'STOCK',
						list: '+dollarVolume',
						filter: 'MAJORCOMPANIES',
						limit: 5
					}}
					columns={dollarVolumeColumns}
					trackingSource="stocks-panel/most-active-stocks"
				/>
			</Container>
			<Container title={<Text id="STOCK_GAINERS" />}>
				<StockList
					showHeaders
					query={{
						type: 'STOCK',
						list: '+percentChange',
						filter: 'MAJORCOMPANIES',
						limit: 5
					}}
					columns={volumeColumns}
					trackingSource="stocks-panel/stock-gainers"
				/>
			</Container>
			<Container title={<Text id="POPULAR_STOCKS" />}>
				<StockList
					showHeaders
					query={{
						type: 'STOCK',
						list: '+popularity',
						filter: 'MAJORCOMPANIES',
						limit: 5
					}}
					columns={volumeColumns}
					trackingSource="stocks-panel/popular-stocks"
				/>
			</Container>
			<Container title={<Text id="STOCK_LOSERS" />}>
				<StockList
					showHeaders
					query={{
						type: 'STOCK',
						list: '-percentChange',
						filter: 'MAJORCOMPANIES',
						limit: 5
					}}
					columns={volumeColumns}
					trackingSource="stocks-panel/stock-losers"
				/>
			</Container>
		</Container>
	);
}

export default containerSize({ height: false })(StocksPanel);
